;(function (angular, _) {
  'use strict'

  class NtLoaderController {
    constructor () {
    }

    $onInit () {
    }
  }

  angular.module('kilo.common.components')
    .component('ntLoader', {
      bindings: {},
      controller: NtLoaderController,
      templateUrl: '/app/common/components/nt-loader/nt-loader.template.html'
    })
})(window.angular, window._)
